module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-custom b-gray br3 w-45 w-100-mobile mb0-l mb2"
  }, [_c('div', {
    staticClass: "flex flex-row justify-between items-center plan-title"
  }, [_c('div', {
    staticClass: "flex flex-column items-center flex-grow-1"
  }, [_c('div', {
    staticClass: "flex flex-row"
  }, [_c('div', [(_vm.isCyberScout) ? _c('upsell-cyber-scout', {
    attrs: {
      "alt": "AKKO Plan",
      "height": "64",
      "width": "64"
    }
  }) : _c('upsell-dashlane', {
    attrs: {
      "alt": "AKKO Plan",
      "height": "64",
      "width": "64"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-grow-1 mr1",
    staticStyle: {
      "margin-left": "0.75rem"
    }
  }, [_c('h5', {
    staticClass: "cera-round-pro mb1",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('h6', {
    staticClass: "gray-text inter fw3",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.content) + "\n          ")])])]), _vm._v(" "), (_vm.includeOpen) ? _c('hr', {
    staticClass: "line",
    class: {
      'line-transition': _vm.includeOpen || _vm.open
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column items-start justify-between plan-details-container w-100",
    class: {
      'plan-details-container-transition': _vm.includeOpen,
      'z-9': _vm.includeOpen
    }
  }, [_c('div', {
    staticClass: "plan-details-container-text inter",
    class: {
      'plan-details-container-text-transition': _vm.includeOpen
    }
  }, [_c('div', {
    staticClass: "mt3"
  }, _vm._l((_vm.planInfoStrings), function(planInfoString, index) {
    return _c('div', {
      key: index,
      staticClass: "pb2 flex items-center"
    }, [_c('img', {
      staticClass: "pr2",
      attrs: {
        "alt": "✓",
        "height": "11",
        "src": "/static/appicons/CheckNotRound.svg"
      }
    }), _vm._v("\n              " + _vm._s(planInfoString) + "\n            ")])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afac528e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/PlanCardUpsell.vue
// module id = 1001
// module chunks = 0